import React from 'react';
import clsx from 'clsx';
import TableFilter from './tableFilter';
import TableFunction from './tableFunction';
import ColumnSelector from './columnSelector';

const TableBar = (props) => {
    const { filters, functions, columnSelectors, wrap = false, className, style } = props;

    return (
        <div
            className={clsx('p-2 flex justify-between items-center', className)}
            style={{ height: 42, ...style }}
        >
            <div
                className={clsx(
                    functions?.length || columnSelectors?.length ? 'w-[calc(100%_-_60px)]' : 'w-full'
                )}
            >
                <TableFilter filters={filters} wrap={wrap} />
            </div>
            {!!(functions?.length || columnSelectors?.length) && (
                <div className="flex">
                    <TableFunction functions={functions} />
                    <ColumnSelector selectors={columnSelectors} />
                </div>
            )}
        </div>
    );
};

export default TableBar;
